import { render, staticRenderFns } from "./ViewMaintenanceDetail.vue?vue&type=template&id=256f1042"
import script from "./ViewMaintenanceDetail.vue?vue&type=script&lang=js"
export * from "./ViewMaintenanceDetail.vue?vue&type=script&lang=js"
import style0 from "./ViewMaintenanceDetail.vue?vue&type=style&index=0&id=256f1042&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports